/**
 * "Reconectar" da faixa de rede (BUG-260).
 *
 * Derruba e reabre os streams do Firestore — o mesmo ciclo
 * `disableNetwork`/`enableNetwork` que o `FirestoreResumeWatcher` roda na
 * retomada do app. O que ele compra é ZERAR o backoff do SDK: depois de
 * várias falhas seguidas a próxima tentativa automática pode estar a 60 s, e
 * quem acabou de sair do túnel não quer esperar um minuto olhando skeleton.
 *
 * Corre contra o relógio de `cycleFirestoreNetwork` (fila do Firestore presa
 * não pode segurar o botão para sempre) e NUNCA rejeita: o desfecho aparece
 * na própria faixa — `fromCache: false` na sonda apaga o aviso, e nada
 * acontecendo é a resposta honesta de "a rede ainda não voltou".
 *
 * Mora fora do componente porque exportar função de arquivo de componente
 * quebra o fast refresh (regra `react-refresh/only-export-components`).
 */
import { disableNetwork, enableNetwork } from "firebase/firestore";
import { db } from "./config";
import { cycleFirestoreNetwork } from "./firestoreHealth";

export async function reconnectFirestore(): Promise<void> {
  await cycleFirestoreNetwork(async () => {
    await disableNetwork(db);
    await enableNetwork(db);
  });
}
